/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["custom-page{display:block;height:100%;width:100%;flex:1 1 auto;overflow:auto}custom-page>.page-body{padding:25px;font-size:1.6rem;font-weight:400;line-height:24px}custom-page>.page-body h2{font-size:2.4rem;line-height:normal;font-weight:400;padding-top:30px;margin-top:45px;border-top:1px solid #e0e0e0}custom-page>.page-body h2:first-child{border-top:none;margin-top:0;padding-top:0;margin-bottom:22px}"];
export { styles as styles };
